import gql from 'graphql-tag';

export const listSettingColumnFragment = gql`
  fragment listSettingColumnFragment on ListSettingColumn {
    dokkioClass
    listSettingID
    columnType
    columnWidth
    sortOrder
  }
`;
export default listSettingColumnFragment;
